import type { ApprovalKindLadder } from '@chukua/common';
import { Button, Tag } from 'antd';
import { Landmark, Pencil } from 'lucide-react';
import { formatMoney } from './format-money';

interface LadderCardProps {
  ladder: ApprovalKindLadder;
  roleName: (key: string) => string;
  onEdit: () => void;
}

/** One approval kind: its ladder read-only, plus the fixed Admin ceiling row above the top tier. */
export function LadderCard({ ladder, roleName, onEdit }: LadderCardProps) {
  return (
    <div className="rounded-lg border border-line bg-surface p-6">
      <div className="mb-4 flex items-start justify-between gap-3">
        <div className="flex flex-wrap items-center gap-2">
          <Landmark className="size-4 text-muted" />
          <h2 className="text-sm font-semibold text-fg">{ladder.name}</h2>
          {!ladder.thresholdsConfirmed && (
            <Tag color="warning" className="m-0">
              Placeholder — needs confirmation
            </Tag>
          )}
        </div>
        <Button size="small" icon={<Pencil className="size-3.5" />} onClick={onEdit}>
          Edit ladder
        </Button>
      </div>
      <ul className="space-y-1.5 text-sm">
        {ladder.tiers.map((tier) => (
          <li key={tier.roleKey + tier.amount.amountMinor} className="flex items-baseline justify-between gap-3">
            <span className="text-muted">Up to {formatMoney(tier.amount)}</span>
            <span className="font-medium text-fg">{roleName(tier.roleKey)}</span>
          </li>
        ))}
        <li className="flex items-baseline justify-between gap-3 border-t border-line pt-1.5">
          <span className="text-muted">Above that</span>
          <span className="font-medium text-fg">Admin</span>
        </li>
      </ul>
    </div>
  );
}
